import { BodyOf } from "../../core/api";
import { createMutationGroup } from "../../core/api/mutations";
import { OfficeId, PlanOfCareItemId, PlanOfCareTypeId } from "../../shared/schema/schema";

export default createMutationGroup(({ api, createMutation }) => ({
  createType: () =>
    createMutation({
      mutationFn: (body: BodyOf<"post", "./custom_plan_of_care_type">) =>
        api.post("./custom_plan_of_care_type", { body }),
    }),

  /** Seeds an office's plan of care from the global Medflyt template. */
  copyFromTemplate: (officeId: OfficeId) =>
    createMutation({
      mutationFn: () =>
        api.post("./offices/:officeId/plan_of_care/copy_from_template", {
          path: { officeId },
        }),
    }),

  patchType: (planOfCareTypeId: PlanOfCareTypeId) =>
    createMutation({
      mutationFn: (body: BodyOf<"patch", "./plan_of_care_type/:planOfCareTypeId">) =>
        api.patch("./plan_of_care_type/:planOfCareTypeId", {
          path: { planOfCareTypeId },
          body,
        }),
    }),

  addItems: (planOfCareTypeId: PlanOfCareTypeId) =>
    createMutation({
      mutationFn: (body: BodyOf<"post", "./plan_of_care_type/:planOfCareTypeId/items">) =>
        api.post("./plan_of_care_type/:planOfCareTypeId/items", {
          path: { planOfCareTypeId },
          body,
        }),
    }),

  setItemActive: (params: {
    planOfCareTypeId: PlanOfCareTypeId;
    planOfCareItemId: PlanOfCareItemId;
  }) =>
    createMutation({
      mutationFn: (
        body: BodyOf<"patch", "./plan_of_care_type/:planOfCareTypeId/items/:planOfCareItemId">
      ) =>
        api.patch("./plan_of_care_type/:planOfCareTypeId/items/:planOfCareItemId", {
          path: params,
          body,
        }),
    }),

  /**
   * Replaces the service codes an item applies to, agency-wide. An empty list means every
   * service code; a visit billing a code outside the list does not show the duty.
   */
  setItemServiceCodes: (params: {
    planOfCareTypeId: PlanOfCareTypeId;
    planOfCareItemId: PlanOfCareItemId;
  }) =>
    createMutation({
      mutationFn: (
        body: BodyOf<
          "put",
          "./plan_of_care_type/:planOfCareTypeId/items/:planOfCareItemId/service_codes"
        >
      ) =>
        api.put("./plan_of_care_type/:planOfCareTypeId/items/:planOfCareItemId/service_codes", {
          path: params,
          body,
        }),
    }),
}));
